import { useState } from "react";
import "./PagingComponent.css";

function PagingComponent({
  currentPage,
  totalPage,
  searchParams,
  setSearchParams,
}) {
  const [currentStatus, setCurrentStatus] = useState(
    parseInt((currentPage - 1) / 10)
  );

  let page = null;
  if (totalPage[currentStatus] && totalPage[currentStatus].length !== 0) {
    page = totalPage[currentStatus].map((i) => {
      return (
        <button
          key={i}
          onClick={() => {
            onclickNum(i);
          }}
          className={i == currentPage ? "now" : ""}
        >
          {i}
        </button>
      );
    });
  } else {
    page = () => {
      return null;
    };
  }

  const onClickFirst = () => {
    searchParams.set("currentPage", 1);
    setSearchParams(searchParams);
    setCurrentStatus(0);
  };

  const onClickPre = () => {
    if (currentStatus > 0) {
      setCurrentStatus(currentStatus - 1);
    }
  };

  const onClickNext = () => {
    if (currentStatus < totalPage.length - 1) {
      setCurrentStatus(currentStatus + 1);
    }
  };

  const onClickFinal = () => {
    const lastList = totalPage[totalPage.length - 1];
    searchParams.set("currentPage", lastList[lastList.length - 1]);
    setSearchParams(searchParams);
    setCurrentStatus(totalPage.length - 1);
  };

  function onclickNum(num) {
    searchParams.set("currentPage", num);
    setSearchParams(searchParams);
  }

  return (
    <div className="pagination">
      <button
        onClick={() => {
          onClickFirst();
        }}
      >
        &lt;&lt;
      </button>
      <button
        onClick={() => {
          onClickPre();
        }}
      >
        &lt;
      </button>

      {page}

      <button
        onClick={() => {
          onClickNext();
        }}
      >
        &gt;
      </button>
      <button
        onClick={() => {
          onClickFinal();
        }}
      >
        &gt;&gt;
      </button>
    </div>
  );
}

export default PagingComponent;
